import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';

const Container = styled.section`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > * {
    opacity: 0;
  }

  > img {
    width: 96px;
  }

  h2 {
    margin: 0;
  }

  p {
    margin: 0;
    text-align: center;
  }
`;

const pos = y => `translateY(${y}px)`;
const neg = y => `translateY(${-y}px)`;

export default function SuccessInfo({ organization }) {
  const { opacity, y } = useSpring({
    opacity: 1,
    y: 0,
    from: { opacity: 0, y: 150 },
  });

  return (
    <Container>
      <animated.img
        src={window.getLivewireAssetPath('success-icon.svg')}
        alt="Success"
        style={{ opacity, transform: y.interpolate(neg) }}
      />
      <animated.h2 style={{ opacity, transform: y.interpolate(pos) }}>Success</animated.h2>
      <animated.p style={{ opacity, transform: y.interpolate(pos) }}>
        Your enquiry has been sent to
        <br />
        {organization}
      </animated.p>
    </Container>
  );
}

SuccessInfo.propTypes = {
  organization: PropTypes.string.isRequired,
};
